(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // SCRIPT OPTIMIZADO PARA ABRIR MENÚS AL PASAR EL MOUSE (HOVER) BOTH+HIS
  document.addEventListener('DOMContentLoaded', () => {
    if (window.innerWidth >= 990) {
      const detailsElements = document.querySelectorAll('.header__inline-menu details');
      const overlay = document.querySelector('.mega-menu-overlay');
      if (overlay && overlay.parentElement !== document.body) {
        document.body.appendChild(overlay);
      }

      function closeAllMenus() {
        detailsElements.forEach((d) => d.removeAttribute('open'));
        document.body.classList.remove('mega-menu-open');
      }

      detailsElements.forEach((details) => {
        let timeoutId;

        // 1. Al entrar el mouse abrimos de inmediato
        details.addEventListener('mouseenter', () => {
          clearTimeout(timeoutId); // Cancelamos cualquier orden de cierre activa
          details.setAttribute('open', 'true');
          document.body.classList.add('mega-menu-open');
        });

        // 2. Al salir el mouse damos un margen de espera prudente
        details.addEventListener('mouseleave', () => {
          // Un retraso de 150ms da una transición perfecta sin cierres accidentales
          timeoutId = setTimeout(() => {
            if (!details.matches(':hover')) {
              details.removeAttribute('open');
              const stillOpen = Array.from(detailsElements).some((d) => d.hasAttribute('open'));
              if (!stillOpen) {
                document.body.classList.remove('mega-menu-open');
              }
            }
          }, 150);
        });

        // 3. Evitamos que el clic rompa el comportamiento del hover
        const summary = details.querySelector('summary');
        if (summary) {
          summary.addEventListener('click', (e) => {
            if (details.hasAttribute('open')) {
              // Si ya está abierto por el mouse, evitamos que el clic nativo lo cierre de golpe
              e.preventDefault();
            }
          });
        }
      });

      // 4. Clic afuera del menú (sobre el overlay) lo cierra
      if (overlay) {
        overlay.addEventListener('click', closeAllMenus);
      }
    }
  });
  

  } catch(e) { console.error(e); }
})();
})();
